import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const MdmActivitySearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .radio-container {
    padding: 24px 0px 0px 16px;

    ${responsive.MOBILE`
      padding: 16px 8px 0px 8px;
    `}
  }

  .form-header-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    .MuiButton-root {
      height: auto;
      padding-left: 4px;
    }
    svg {
      margin-right: 10px;
    }
  }

  .form-container {
    padding: 0px 0px 24px 16px;
    ${responsive.MOBILE`
     padding: 0px 8px 0px 0px;
    `}
  }

  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    padding-top: 32px;
    ${responsive.MOBILE`
      flex-direction:column-reverse;
        padding-bottom: 16px;
        padding-top: 0px;
        padding-right: 8px;
    `}
    button {
      margin-right: 16px;
      ${responsive.MOBILE`
        width:100%;
        margin:16px 0px 0px;
      `}
    }
  }
  .MuiGrid2-root {
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
    ${responsive.MOBILE`
      padding-left: 8px;
      padding-right: 8px;
    `}
  }

  .confirm-message {
    line-height: 20px;
    margin-bottom: 8px;
    color: ${COLORS.cirrus_black10};
  }

  .item-name {
    line-height: 20px;
    color: ${COLORS.cirrus_black10};
  }
  .reset-all-button {
    margin-right: 38px;
  }
`;
